export const appointmentTypeColumns = [
  {
    title: 'Cancel Type',
    key: 'title',
    dataIndex: 'title'
  }
];
